import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useSSRSelector } from '@/redux/ssrStore';

export const Heading = (props) => (
  <h3 className="tw-text-7 tw-m-0 tw-text-xl">{props.children}</h3>
);

export const Para = (props) => (
  <p
    className={`tw-m-0 ${props?.large ? 'tw-text-base/5' : 'tw-text-sm'} tw-font-normal tw-text-[#4E4E4E] ${props.className || ''}`}
  >
    {props.children}
  </p>
);

export const PrimaryBtn = ({ text, onClick, disabled = false, className = '' }) => {
  const theme = useSSRSelector((state) => state.storeReducer.store.theme);
  const primaryColor = theme?.colors?.primary_color;
  const rounded = theme?.roundness;

  return (
    <button
      className={`tw-rounded-lg tw-border-0 tw-bg-[#2B74D8] tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white ${disabled ? 'tw-opacity-30' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: primaryColor,
        borderRadius: rounded,
      }}
    >
      {text}
    </button>
  );
};

export const SecondaryBtn = ({ text, onClick, disabled = false, className = '' }) => (
  <button
    className={`tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-[#222222] ${disabled ? 'tw-opacity-35' : ''} ${className}`}
    onClick={onClick}
    disabled={disabled}
  >
    {text}
  </button>
);

export const Option = ({ reason, isSelected, onSelect }) => (
  <div className="tw-flex tw-items-center tw-gap-2.5" onClick={onSelect}>
    {isSelected ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
    <Para large>{reason}</Para>
  </div>
);

export const ActionTab = ({ Icon, text, handler }) => {
  return (
    <button
      className="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-none tw-border-0 tw-border-b tw-border-solid tw-border-[#E0E0E0] tw-bg-transparent tw-px-4 tw-py-5 tw-text-black last:tw-border-0"
      onClick={handler}
    >
      <Icon />
      {text}
    </button>
  );
};
